import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  margin: 80px 0px 0px 0px;

  // Logos Container
  .logosContainer {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
    align-items: center;
  }

  // Logos
  .logosContainer img {
    display: block;
  }

  // Logos images
  #prudenciaLogo {
    max-width: 180px;
  }

  #patronalLogo {
    max-width: 240px;
  }

  #segundaLogo {
    max-width: 225px;
  }

  // Mucho Para Vos Container
  .muchoParaVosContainer {
    width: 100%;
    max-width: 1040px;
    display: flex;
    margin: 0 auto;
    margin-top: 70px;
    justify-content: space-between;
    flex-wrap: wrap;
    flex-direction: row;
  }

  // Mucho Para Vos Title
  .muchoParaVosContainer h2 {
    width: 100%;
    font-family: "Raleway", sans-serif;
    font-size: 2.25em;
    font-style: normal;
    font-weight: bold;
    color: var(--black);
    text-align: center;
    letter-spacing: -0.015em;
    margin: 25px 0px 0px 0px;
  }

  // Cubrimos Container
  .cubrimosContainer {
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
    flex-wrap: wrap !important;
    flex-direction: row;
    margin-top: 80px;
  }

  // Columns Cubrimos
  .cubrimosColumn {
    width: 33.3%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
  }

  // Line Break
  .line-break {
    width: 100%;
  }

  // Cubre
  .cubre {
    padding: 7px 31px 7px 31px;
    margin: 0px 0px 40px 0px;
    background: rgba(255, 211, 171, 0.2);
    border-radius: 12px;
    display: flex;
    align-items: center;
  }

  // Cubre Text
  .cubre p {
    font-family: Raleway;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    color: var(--black);
    margin: 0px 0px 0px 0px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }

  // Cubre Icon
  .cubre p span {
    color: var(--green);
    font-size: 1.2em;
    margin: 5px 15px 0px 0px;
  }

  // Cotizar Button
  a {
    margin: 0 auto;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 1.1em;
    color: var(--white);
    padding: 12px 40px 12px 40px;
    border-radius: 6px;
    background-color: var(--orange);
    margin-top: 40px;
    border: 0px solid;
    transition: 0.2s;
    cursor: pointer;
  }

  // Cotizar Button Hover
  a:hover {
    background-color: var(--lightorange);
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Mucho Para Vos Title
    .muchoParaVosContainer h2 {
      font-size: 2em;
    }

    // Cubre Text
    .cubre p {
      font-size: 0.96em;
    }

    // Cotizar Button
    a {
      font-size: 1.1em;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Mucho Para Vos Title
    .muchoParaVosContainer h2 {
      font-size: 1.9em;
    }

    // Cubre Text
    .cubre p {
      font-size: 0.938em;
    }

    // Cotizar Button
    a {
      font-size: 1em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    // Logos Container
    .logosContainer {
      max-width: 650px;
    }

    // Logos images
    #prudenciaLogo {
      max-width: 160px;
    }

    #patronalLogo {
      max-width: 200px;
    }

    #segundaLogo {
      max-width: 188px;
    }

    // Mucho Para Vos Container
    .muchoParaVosContainer {
      max-width: 950px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Logos Container
    .logosContainer {
      max-width: 550px;
    }

    // Logos images
    #prudenciaLogo {
      max-width: 130px;
    }

    #patronalLogo {
      max-width: 180px;
    }

    #segundaLogo {
      max-width: 168px;
    }

    // Mucho Para Vos Container
    .muchoParaVosContainer {
      max-width: 750px;
    }

    // Cubre
    .cubre {
      padding: 5px 21px 5px 21px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    // Logos Container
    .logosContainer {
      max-width: 540px;
    }

    // Mucho Para Vos Container
    .muchoParaVosContainer {
      display: none;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    // Logos Container
    .logosContainer {
      max-width: 480px;
    }

    // Logos images
    #prudenciaLogo {
      max-width: 138px;
    }

    #patronalLogo {
      max-width: 153px;
    }

    #segundaLogo {
      max-width: 153px;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    margin: 50px 0px 0px 0px;

    // Logos Container
    .logosContainer {
      max-width: 480px;
    }
  }

  // 550px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile550}) {
    // Logos Container
    .logosContainer {
      max-width: 88%;
      justify-content: center;
    }

    // Logos images
    #prudenciaLogo {
      max-width: 118px;
      margin: 0px 10px 0px 10px;
    }

    #patronalLogo {
      max-width: 163px;
      margin: 0px 10px 0px 10px;
    }

    #segundaLogo {
      max-width: 143px;
      margin: 30px 10px 0px 10px;
    }
  }

  // 525px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile525}) {
    margin: 0px 0px 0px 0px;
  }

  // 375px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile375}) {
    // Logos Container
    .logosContainer {
      max-width: 85%;
    }

    #patronalLogo {
      margin: 30px 10px 0px 10px;
    }

    #segundaLogo {
      margin: 40px 10px 0px 10px;
    }
  }
`;

export default Container;
